import { Image } from 'react-native';

export const getImageSize = (uri: string) => {
  return Image.getSize(uri);
};
